import './js/define-main-object.js';

import './js/ulgm-rest-forms.js';
import './js/ulgm-assignments.js';
import './js/ulgm-essays.js';
import './js/ulgm-reporting.js';
import './js/front.js';
import './js/learndash_template_script.js';
import './js/uncanny-owl-groups-ui.js';

import GroupManagement from './js/group-management.js';
import GroupCourseReport from './js/group-course-report.js';
import CourseDashboard from './js/course-dashboard.js';
import ManageProgress from './js/manage-progress.js';
import BuyCourses from './js/buy-courses.js';
import CreateGroup from './js/create-group.js';

import './scss/main.scss';

// Do on DOM ready
document.addEventListener( 'DOMContentLoaded', () => {
	new GroupManagement();
	new GroupCourseReport();
	new CourseDashboard();
	new ManageProgress();
	new BuyCourses();
	new CreateGroup();
});
